export default "__VITE_ASSET__AvHyY5VC__"